<template>
  <div :class="cityPanelStatus ? 'nhl_city active' : 'nhl_city'" >
    <div class="city_title">当前定位城市</div>
    <div class="city_currentSelect">
      <div @click="FLSelectCity()" class="item">{{city}}</div>
    </div>
    <div class="city_stitle">热门城市</div>
    <div class="city_item">
      <div @click="FLSelectCityItem(cityItem,cityIndex)" v-for="(cityItem,cityIndex) in city_list" :key="cityIndex" class="item">{{cityItem.name}}</div>
    </div>
    <v-touch v-on:swipeup="FLSwipertop">
      <div class="city_gif" @click="FLSelectCity()">
        <img src="../../assets/images/base/upArrowGray.gif" />
      </div>
    </v-touch>
  </div>
</template>

<script>
  export default {
    props:{
      cityPanelStatus:Boolean,
      city:String,
      city_list:Array
      // radio:String,
      // loaded:Boolean,
      // fl_stadium_list:Array,
    },
    data() {
      return {

      }
    },
    created() {},
    mounted() {

    },
    methods:{
      FLSelectCity(){
        this.$emit('FLSelectCity')
      },
      FLSelectCityItem(item,index){
        this.$emit('FLSelectCityItem',item,index)
      },
      FLSwipertop(){
        this.$emit('FLSwipertop')
      }
      // FLDetail(item,index){
      //   this.$emit('FLDetail',item,index)
      // },
      // FLCreate(item,index){
      //   this.$emit('FLCreate',item,index)
      // }
    }
  }
</script>

<style lang="less" scoped="scoped">
  @vm_base: 1/750*100vw;
  // 城市面板
  .nhl_city{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 0;
    margin-top: 90*@vm_base;
    background: #FFFFFF;
    z-index:100;
    overflow: hidden;
    transition:all .5s ease-in;
    .city_title{
      width: 100%;
      padding: 24*@vm_base 0 24*@vm_base 32*@vm_base;
      background: #FBFBFB;
      font-size: 24*@vm_base;
      font-weight: 500;
      color: #8F8C98;
    }
    .city_currentSelect{
      width: 100%;
      padding: 32*@vm_base 0 32*@vm_base 44*@vm_base;
      background: #FFFFFF;
      .item{
        width: 140*@vm_base;
        text-align: center;
        background: #444054;
        border-radius: 6*@vm_base;

        font-size: 32*@vm_base;
        font-weight: 500;
        color: #FFFFFF;
        padding: 14*@vm_base 0;
      }
    }
    .city_stitle{
      width: 100%;
      padding: 24*@vm_base 0 24*@vm_base 32*@vm_base;
      background: #F5F5F5;
      font-size: 24*@vm_base;
      font-weight: 500;
      color: #8F8C98;
    }
    .city_item{
      width: 100%;
      height: 650*@vm_base;
      //calc(100vh - 574*@vm_base);
      overflow-y: auto;
      padding: 40*@vm_base 10*@vm_base 0 10*@vm_base;
      background: #FFFFFF;
      .item{
        width: 140*@vm_base;
        text-align: center;
        padding: 14*@vm_base 0;
        margin-left: 34*@vm_base;
        border-radius: 6*@vm_base;
        border: 1*@vm_base solid #979797;
        float: left;
        margin-bottom: 40*@vm_base;
        font-size: 32*@vm_base;
        font-weight: 500;
        color: #444054;
      }
    }
    .city_gif{
      width: 100%;
      height:calc(100vh - 1050*@vm_base);
      // padding-top: 80*@vm_base;
      position: relative;
      img{
        position: absolute;
        bottom: 0;
        left: 0;
        width: 90%;
        margin-left: 5%;
      }
    }
  }
  .nhl_city.active{
    height: calc(100vh - 90*@vm_base);
    transition:all .5s ease-in;
  }
</style>



// WEBPACK FOOTER //
// src/components/subgroup/appointmentCityPanel.vue